import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

interface FeeData {
  customGasPrice: bigint;
  customMaxFeePerGas: bigint;
  customMaxPriorityFeePerGas: bigint;
}

export function useFeeData(): FeeData {
  const [customGasPrice, setCustomGasPrice] = useState<bigint>(0n);
  const [customMaxFeePerGas, setCustomMaxFeePerGas] = useState<bigint>(0n);
  const [customMaxPriorityFeePerGas, setCustomMaxPriorityFeePerGas] = useState<bigint>(0n);
  
  const { feeType, fees, extraFloat } = useSelector((state: any) => state.projectControll);

  useEffect(() => {
    const getCustomFeeData = () => {
      const { gasPrice, maxFeePerGas, maxPriorityFeePerGas } = fees;

      if(!gasPrice || !maxFeePerGas || !maxPriorityFeePerGas) return;
      
      // 计算基础费用
      let baseGasPrice = BigInt(gasPrice * feeType);
      let baseMaxFeePerGas = BigInt(maxFeePerGas);
      let baseMaxPriorityFeePerGas = BigInt(maxPriorityFeePerGas * feeType);

      // 如果extraFloat大于0，增加相应百分比
      if (extraFloat > 0) {
        const multiplier = BigInt(100 + extraFloat);
        baseGasPrice = (baseGasPrice * multiplier) / 100n;
        baseMaxFeePerGas = (baseMaxFeePerGas * multiplier) / 100n;
        baseMaxPriorityFeePerGas = (baseMaxPriorityFeePerGas * multiplier) / 100n;
      }

      setCustomGasPrice(baseGasPrice);
      setCustomMaxFeePerGas(baseMaxFeePerGas);
      setCustomMaxPriorityFeePerGas(baseMaxPriorityFeePerGas);
    };

    getCustomFeeData();
  }, [feeType, fees, extraFloat]);

  return {
    customGasPrice,
    customMaxFeePerGas,
    customMaxPriorityFeePerGas
  };
}